import * as React from 'react';
import cx from 'classnames';
import Link from '@src/components/link';
import { ARTICLE_ID } from '@src/constants/articles';
const styles = require('./index.less');

// 公共组件导航：跨内页复用的底部导航条（5 内页入口 + 返回首页）
// 受控展示件——当前页高亮由 activeId(articleId) 决定，跳转/提示/返回首页均走页面注入的回调，
// 组件不持有状态、不写路由副作用（controlled-static-shell-boundary）
const PublicNav = ({ className, activeId, onNavToList, onBackHome, onComingSoon }) => {
  return (
    <div className={cx(styles.root, className)} data-name={'公共组件 - 导航'}>
      <div className={styles.layer20} data-name={'背景'} />
      <div className={styles.group17} data-name={'tab - 按钮list'}>
        <Link className={styles.group18} data-name={'5 - 天下第一 帮会巅峰'} onClick={onComingSoon}>
          <div className={styles.layer21} data-name={'天下第一 帮会巅峰-常态'} />
          <div className={styles.layer22} data-name={'天下第一 帮会巅峰-选中/悬浮'} />
        </Link>
        <Link
          className={cx(styles.group19, { [styles.active]: activeId === ARTICLE_ID.WELFARE_CARNIVAL })}
          data-name={'4 - 福利狂欢 金币66600'}
          onClick={() => onNavToList(ARTICLE_ID.WELFARE_CARNIVAL)}
        >
          <div className={styles.layer23} data-name={'福利狂欢 金币66600-常态'} />
          <div className={styles.layer24} data-name={'福利狂欢 金币66600-选中/悬浮'} />
        </Link>
        <Link
          className={cx(styles.group20, { [styles.active]: activeId === ARTICLE_ID.RESERVE_SERVER })}
          data-name={'3 - 预约新服 百万绑金'}
          onClick={() => onNavToList(ARTICLE_ID.RESERVE_SERVER)}
        >
          <div className={styles.layer25} data-name={'预约新服 百万绑金-常态'} />
          <div className={styles.layer26} data-name={'预约新服 百万绑金-选中/悬浮'} />
        </Link>
        <Link
          className={cx(styles.group21, { [styles.active]: activeId === ARTICLE_ID.BURDEN_OPTIMIZATION })}
          data-name={'2 - 减负调优 轻松武侠'}
          onClick={() => onNavToList(ARTICLE_ID.BURDEN_OPTIMIZATION)}
        >
          <div className={styles.layer27} data-name={'减负调优 轻松武侠-常态'} />
          <div className={styles.layer28} data-name={'减负调优 轻松武侠-选中/悬浮'} />
        </Link>
        <Link
          className={cx(styles.group22, { [styles.active]: activeId === ARTICLE_ID.BATTLE_TERRITORY })}
          data-name={'1 - 战域领土 荣耀嘉奖'}
          onClick={() => onNavToList(ARTICLE_ID.BATTLE_TERRITORY)}
        >
          <div className={styles.layer29} data-name={'战域领土 荣耀嘉奖-常态'} />
          <div className={styles.layer30} data-name={'战域领土 荣耀嘉奖-选中/悬浮'} />
        </Link>
        <Link className={styles.group23} data-name={'返回首页'} onClick={onBackHome}>
          <div className={styles.layer31} data-name={'返回首页-选中/悬浮'} />
          <div className={styles.layer32} data-name={'返回首页-常态'} />
        </Link>
      </div>
    </div>
  );
};

export default PublicNav;
